import { TBuilders } from '../../types/redux/state';
import { TReduxActions } from '../../types/redux';
import { EBuildersInfoActionTypes } from '../../actions/buildersInfo';

export const buildersReducer = (state: TBuilders = [], action: TReduxActions) => {
  switch (action.type) {
    case EBuildersInfoActionTypes.Success:
      return [...action.payload.developers];

    default:
      return state;
  }
};
